import * as React from "react"

const SvgMobileMenuRedShape = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={351.868}
    height={208.284}
    viewBox="0 0 351.868 208.284"
    {...props}
  >
    <path d="M351.868 0 0 36.683v171.6h351.868Z" fill="#ce1213" />
  </svg>
)

export default SvgMobileMenuRedShape
